import { useMediaQuery } from 'react-responsive';

export type ViewportInfo = {
    /** True at 1224px and narrower - drives heading size/weight and input width decisions on
     * Home, NewPassword, and TestPassword today. */
    isTabletOrMobile: boolean;
    /** True when the viewport is taller than it is wide. */
    isPortrait: boolean;
    /** True at Abyss's own "mobile" breakpoint (< 744px, the `$md` token @uhg-abyss/web/tools/styled
     * defines as ScreenQueries.SmallerThanMedium) - narrower than isTabletOrMobile, used where a
     * layout needs to distinguish true mobile from tablet. */
    isMobile: boolean;
};

// Central source of truth for viewport-based layout decisions, so pages/components don't each
// run their own ad hoc useMediaQuery calls. Grow this hook with additional checks as new layout
// needs come up, rather than adding another one-off useMediaQuery call at the call site.
export const useViewport = (): ViewportInfo => {
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });
    const isMobile = useMediaQuery({ query: '(max-width: 744px)' });

    return { isTabletOrMobile, isPortrait, isMobile };
};
